import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import counterSection from './sections/counters';
import articlesSection from './sections/articles';
import orderForm from './sections/order-form';
import { onResize } from './utils/window';

/** boilerplate specific sections */
counterSection();
init();
modalSection();
headerSection();
articlesSection();
orderForm();

/** location suggest */
const locationInput = document.querySelector('input[name="location"]');
if (locationInput) {
  const suggestionDiv = document.querySelector('#dropoff-location-suggest');
  locationInput.addEventListener('keyup', async function() {
    try {
      const response = await fetch('/address-lookup', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          input: locationInput.value
        })
      });
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const json = await response.json();

      suggestionDiv.innerHTML = '';
      if (json.length > 0) {
        json.forEach(item => {
          let entry = document.createElement("span");
          entry.innerHTML = item;
          entry.addEventListener('click', () => {
            locationInput.value = item;
            suggestionDiv.innerHTML = '';
            suggestionDiv.classList.remove('appeared');
  
          });
          suggestionDiv.classList.add('appeared');
          suggestionDiv.appendChild(entry);
        });
      }

    } catch (error) {
      console.error(error.message);
    }
  });
}


/** fix cta background heights */
const fixCtaHeights = () => {
  document.querySelectorAll('.module--module-cta__background').forEach(element => {
    element.style.height = `${element.parentNode.offsetHeight + 20}px`;
  });
}
onResize(fixCtaHeights);
fixCtaHeights();



// WEBPACK FOOTER //
// ./source/scripts/main.js